module.exports = {"id":"dp4_2l3q1","text":"Protecting personal data and privacy","instructions":"How important is careful handling of children's personal data online?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"Scale","random":false,"options":[{"id":"dp4_2l3q1-a1","text":"Very important","score":4},{"id":"dp4_2l3q1-a2","text":"Important","score":3.6},{"id":"dp4_2l3q1-a3","text":"Neutral","score":3},{"id":"dp4_2l3q1-a4","text":"Unimportant","score":2.4},{"id":"dp4_2l3q1-a5","text":"Not important","score":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q1.json
// module id = 1228
// module chunks = 41